<script setup>
import { computed } from 'vue'

const props = defineProps({
    item: { type: Object, required: true },
    // { kind, text, when }
})

const style = computed(() => {
    const map = {
        new:     { bg: '#DDE8FA', fg: '#1C4FA0' },
        confirm: { bg: '#E0F2E7', fg: '#0F5B3A' },
        cancel:  { bg: '#F4E0DE', fg: '#8A2722' },
        change:  { bg: '#EFE7FA', fg: '#6A37A8' },
        client:  { bg: '#FFF1E2', fg: '#A04A1F' },
        form:    { bg: '#F1F1F4', fg: '#6B7280' },
    }
    return map[props.item.kind] ?? map.form
})
</script>

<template>
    <div class="flex gap-3 py-2">
        <div
            class="w-[30px] h-[30px] rounded-[9px] flex items-center justify-center flex-shrink-0"
            :style="{ background: style.bg, color: style.fg }"
        >
            <!-- new -->
            <svg v-if="item.kind === 'new'" class="w-[15px] h-[15px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg>
            <!-- confirm -->
            <svg v-else-if="item.kind === 'confirm'" class="w-[15px] h-[15px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="m4 12 5 5L20 6"/></svg>
            <!-- cancel -->
            <svg v-else-if="item.kind === 'cancel'" class="w-[15px] h-[15px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6l-12 12"/></svg>
            <!-- change -->
            <svg v-else-if="item.kind === 'change'" class="w-[15px] h-[15px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>
            <!-- default -->
            <svg v-else class="w-[15px] h-[15px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>
        </div>
        <div class="flex-1 min-w-0 pt-0.5">
            <div class="text-[12.5px] text-gray-900 dark:text-white leading-tight">{{ item.text }}</div>
            <div class="text-[11px] text-gray-300 dark:text-neutral-600 font-medium mt-0.5">{{ item.when }}</div>
        </div>
    </div>
</template>
